import './App.css';
import { MoonPhase } from './MoonPhase';

function App() {
  return (
    <>
    <main className="App">
      <MoonPhase></MoonPhase>
    </main>
    </>
  );
}

export default App;
